const removeSpaces = (text: string): string => text.replace(/\s+/g, '')

export default removeSpaces
